import PropTypes from "prop-types"
import React, { useEffect, useState, useRef } from "react"
import { useDispatch } from "react-redux"
import { Modal, ModalBody } from "reactstrap"

import Flatpickr from "react-flatpickr"
import "flatpickr/dist/themes/material_blue.css"
import { Spanish } from "flatpickr/dist/l10n/es.js"
import classnames from "classnames"
import {
  Button,
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  InputGroup,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"

import { useFormik } from "formik"
import * as Yup from "yup"

import CargosListado from "./CargosListado"
import CargosInsertColegiatura from "./CargosInsertColegiatura"
import CargosInsertReinscripcion from "./CargosInsertReinscripcion"
import { useCajaServicios } from "store/selectors"
import { getCajaServicios as onGetServicios } from "store/actions"

const CargosInsertModal = ({ idAlumno, isLoading }) => {
  //
  Date.prototype.addDays = function (days) {
    var date = new Date(this.valueOf())
    date.setDate(date.getDate() + days)
    return date
  }
  //

  const flatpickrRef = useRef(null)
  const optionsFlatpickr = {
    locale: Spanish,
    altInput: true,
    dateFormat: "d-m-y",
  }
  //
  const dispatch = useDispatch()
  const dataServicios = useCajaServicios()
  //
  //Horizontal form
  const horizontalformik = useFormik({
    initialValues: {
      firstname: "",
      email: "",
      password: "",
      check: "",
    },
    validationSchema: Yup.object({
      firstname: Yup.string().required("This field is required"),
      email: Yup.string()
        .email()
        .matches(/^(?!.*@[^,]*,)/)
        .required("Please Enter Your Email"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .matches(RegExp("(.*[a-z].*)"), "At least lowercase letter")
        .matches(RegExp("(.*[A-Z].*)"), "At least uppercase letter")
        .matches(RegExp("(.*[0-9].*)"), "At least one number")
        .required("This field is required"),
      check: Yup.string().required("This field is required"),
    }),

    onSubmit: values => {
      // console.log("value", values.password);
    },
  })

  useEffect(() => {
    if (dataServicios && dataServicios.length === 0)
      dispatch(
        onGetServicios({
          nombreSolicitud: "getserviciosxidalumno",
          idAlumno: idAlumno,
        })
      )
  }, [useDispatch, dataServicios, idAlumno])

  const [customActiveTab, setcustomActiveTab] = useState("1")

  const toggleCustom = tab => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab)
      console.log("setcustomActiveTab(tab): ", tab)
    }
  }
  return (
    <Row>
      <Col>
        <Nav tabs className="nav-tabs-custom nav-justified">
          <NavItem>
            <NavLink
              style={{ cursor: "pointer" }}
              className={classnames({
                active: customActiveTab === "1",
              })}
              onClick={() => {
                toggleCustom("1")
              }}
            >
              <span className="d-block d-sm-none">
                <i className="fas fa-home"></i>
              </span>
              <span className="d-none d-sm-block">Generales</span>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              style={{ cursor: "pointer" }}
              className={classnames({
                active: customActiveTab === "2",
              })}
              onClick={() => {
                toggleCustom("2")
              }}
            >
              <span className="d-block d-sm-none">
                <i className="far fa-user"></i>
              </span>
              <span className="d-none d-sm-block">Colegiatura</span>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              style={{ cursor: "pointer" }}
              className={classnames({
                active: customActiveTab === "3",
              })}
              onClick={() => {
                toggleCustom("3")
              }}
            >
              <span className="d-block d-sm-none">
                <i className="far fa-envelope"></i>
              </span>
              <span className="d-none d-sm-block">Reinscripción</span>
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={customActiveTab} className="p-3 text-muted">
          <TabPane tabId="1">
            <Row>
              <Col sm="12">
                <CargosListado
                  dataServicios={dataServicios}
                  isLoding={isLoading}
                />
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="2">
            <Row>
              <Col sm="12">
                <CargosInsertColegiatura
                  idAlumno={idAlumno}
                  dataServicios={dataServicios}
                  tab={2}
                  customActiveTab={customActiveTab}
                  isLoding={isLoading}
                />
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="3">
            <Row>
              <Col sm="12">
                <CargosInsertReinscripcion
                  idAlumno={idAlumno}
                  dataServicios={dataServicios}
                  tab={3}
                  customActiveTab={customActiveTab}
                  isLoding={isLoading}
                />
              </Col>
            </Row>
          </TabPane>
        </TabContent>
      </Col>
    </Row>
  )
}

CargosInsertModal.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.any,
}

export default CargosInsertModal
